const handleResponse = async (response: Response) => {
    if (!response.ok) {
        try {
            const errorJson = await response.json();
            throw errorJson;
        } catch (e: any) {
            if (e.detail) {
                throw { error: true, message: e.detail };
            }
            throw {
                error: true,
                message: `${response.status} (${response.statusText})`
            };
        }

    }
    return response.json();
};

const handleError = (error: any) => {
    if (error instanceof TypeError) {
        // Error de red, por ejemplo: conexión rechazada
        return { error: true, message: error.message || 'Error de conexión' };
    }
    // Otro tipo de error (posiblemente lanzado arriba)
    return error;
};

const GET = async (r: { url: string, token?: string }) => {
    try {
        let headers: HeadersInit_ = {
            'Content-Type': 'application/json',
        }
        if (r.token) {
            headers['Authorization'] = `Bearer ${r.token}`;
        }
        const response = await fetch(encodeURI(r.url), {
            method: 'GET',
            headers,
        });
        return await handleResponse(response);
    } catch (error) {
        throw handleError(error);
    }
};

const POST = async (r: { url: string, body: any, token?: string }) => {
    try {
        let headers: HeadersInit_ = {
            'Content-Type': 'application/json',
        }
        if (r.token) {
            headers['Authorization'] = `Bearer ${r.token}`;
        }
        const response = await fetch(encodeURI(r.url), {
            method: 'POST',
            headers,
            body: JSON.stringify(r.body),
        });
        return await handleResponse(response);
    } catch (error) {
        throw handleError(error);
    }
};

const PUT = async (r: { url: string, body: any, token?: string }) => {
    try {
        let headers: HeadersInit_ = {
            'Content-Type': 'application/json',
        }
        if (r.token) {
            headers['Authorization'] = `Bearer ${r.token}`;
        }
        const response = await fetch(encodeURI(r.url), {
            method: 'PUT',
            headers,
            body: JSON.stringify(r.body),
        });
        return await handleResponse(response);
    } catch (error) {
        throw handleError(error);
    }
};

const DELETE = async (r: { url: string, body: any, token?: string }) => {
    try {
        let headers: HeadersInit_ = {
            'Content-Type': 'application/json',
        }
        if (r.token) {
            headers['Authorization'] = `Bearer ${r.token}`;
        }
        const response = await fetch(encodeURI(r.url), {
            method: 'DELETE',
            headers,
            body: JSON.stringify(r.body),
        });
        return await handleResponse(response);
    } catch (error) {
        throw handleError(error);
    }
};

const POST_FORMDATA = async (r: { url: string, body: FormData, token?: string }) => {
    try {
        let headers: HeadersInit_ = {};
        if (r.token) {
            headers['Authorization'] = `Bearer ${r.token}`;
        }
        const response = await fetch(encodeURI(r.url), {
            method: 'POST',
            headers,
            body: r.body,
        });
        return await handleResponse(response);
    } catch (error) {
        throw handleError(error);
    }
};

const HTTP = {
    GET,
    POST,
    PUT,
    DELETE,
    POST_FORMDATA
};

export default HTTP;
